import styled from "styled-components";

export const Container = styled.div``;

export const Title = styled.div`
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 1.5px;
  margin-bottom: 20px;
`;
export const Divider = styled.div`
  margin-top: 5px;
  margin-bottom: 15px;
  border-bottom: 1px solid gray;
`;
export const SubTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1.5px;
  margin-left: 8px;
`;
export const CardContainer = styled.div`
  width: 260px;
  border: 1px solid gray;
  padding: 15px 2px;
  border-radius: 8px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  input {
    border: 0.5px solid gray;
    height: 25px;
  }
`;
export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0 5px 0;
  gap: 8px;

  input {
    border: 0.5px solid gray;
    height: 25px;
  }
`;
export const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 260px;
  padding: 4px 6px;
  border: 1px solid gray;
  border-radius: 4px;

  margin-bottom: 8px;

  cursor: pointer;

  a {
    text-decoration: none;
    color: white;
  }
`;
export const ChannelContainer = styled.div`
  display: grid;
  gap: 10px;
  margin-bottom: 20px;

  @media (min-width: 375px) {
    grid-template-columns: 260px;
  }
  @media (min-width: 650px) {
    grid-template-columns: 260px 260px;
  }
  @media (min-width: 900px) {
    grid-template-columns: 260px 260px 260px;
  }
  @media (min-width: 1160px) {
    grid-template-columns: 260px 260px 260px 260px;
  }
`;
export const ButtonContainer = styled.div`
  display: grid;
  gap: 8px;

  @media (min-width: 375px) {
    grid-template-columns: 260px;
  }
  @media (min-width: 650px) {
    grid-template-columns: 260px 260px;
  }
`
